import React from 'react';

import {
  Box,
  styled,
  Typography as BaseTypography
} from '@mui/material';

import imgHeader from 'assets/images/decorative_header.png';



const Typography = styled(BaseTypography)(({ theme }) => ({
  color: 'white',
  fontSize: 30,
  fontFamily: 'Noto Serif'
}));

const ContainerBox = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(12),
  marginBottom: theme.spacing(9)
}));

const TextBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  background: `url(${imgHeader})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center'
}));



export interface IProps {
  label: string;
}

export const FC: React.FC<IProps> = props => {
  return (
    <ContainerBox>
      <TextBox>
        <Typography>
          {props.label}
        </Typography>
      </TextBox>
    </ContainerBox>
  );
};
